import React from 'react';
import { Link } from 'react-router-dom';
import { Mountain, Mail, Phone, MapPin, Facebook, Instagram, Youtube, MessageCircleMore, Pointer } from 'lucide-react';
import { contactDetails } from '@/data/trekData';
import LogoSVG from '../assets/images/logo-svg.svg';
import WhatsAppIcon from './ui/whatsappIcon';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const sendWhatsAppMessage = () => {
    const url = `https://wa.me/91${contactDetails.whatsapp}?text=${encodeURIComponent(contactDetails.whatsappMessage)}`;
    window.open(url, "_blank");
  };

  return (
    <footer className="bg-slate-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <img
              src={LogoSVG}
              alt="Mountain Mentors Logo"
              className="w-16 h-16 transform scale-150"
              />
              <span className="text-l font-bold text-white">The Mountain Mentors</span>
            </div>
            <p className="text-sm text-gray-400">
              Your trusted partner for unforgettable Himalayan trekking experiences across India.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-orange-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm hover:text-orange-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/treks" className="text-sm hover:text-orange-400 transition-colors">
                  All Treks
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm hover:text-orange-400 transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Popular Treks */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Popular Treks</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/trek/1" className="text-sm hover:text-orange-400 transition-colors">
                  Hampta Pass
                </Link>
              </li>
              <li>
                <Link to="/trek/2" className="text-sm hover:text-orange-400 transition-colors">
                  Kedarkantha Trek
                </Link>
              </li>
              <li>
                <Link to="/trek/3" className="text-sm hover:text-orange-400 transition-colors">
                  Rupin Pass Trek
                </Link>
              </li>
              <li>
                <Link to="/trek/5" className="text-sm hover:text-orange-400 transition-colors">
                  Roopkund Trek
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold text-white mb-4">Contact Us</h3>
            <ul className="space-y-3">
              {/* <li className="flex items-start space-x-2">
                <MapPin className="h-5 w-5 text-orange-500 flex-shrink-0 mt-0.5" />
                <span className="text-sm">Manali, Himachal Pradesh, India</span>
              </li> */}
              <li className="flex items-center space-x-2">
                <Phone className="h-5 w-5 text-orange-500" />
                <span className="text-sm">+91 {contactDetails.phone}</span>
              </li>
              <li className="flex items-center space-x-2">
                <WhatsAppIcon className="h-5 w-5 text-orange-500" />
                <span className="text-sm">+91 {contactDetails.whatsapp}</span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="h-5 w-5 text-orange-500" />
                <span className="text-sm">{contactDetails.email}</span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex space-x-4 mt-6">
              {/* <a
                href="#"
                className="text-gray-400 hover:text-orange-400 transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a> */}

              <div onClick={sendWhatsAppMessage} style={{cursor: "pointer", transition: "0.3s"}}>
                <WhatsAppIcon className="h-5 w-5 whatsapp-svg" />
              </div>
              
              <a
                target="_blank"
                href="https://www.instagram.com/goomusafir?igsh=MTN0dzRvajR4ZDNwcw=="
                className="text-gray-400 hover:text-orange-400 transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              {/* <a
                href="#"
                className="text-gray-400 hover:text-orange-400 transition-colors"
                aria-label="YouTube"
              >
                <Youtube className="h-5 w-5" />
              </a> */}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {currentYear} The Mountain Mentors. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;